// import Home from '../views/Home';
// import Table from '../views/Table';
// import Checkout from '../views/Checkout';
// import Error from '../views/Error';
// import Details from '../views/Details';

const Home = () => import('../views/Home.vue');
const Table = () => import('../views/Table.vue');
const Checkout = () => import('../views/Checkout.vue');
const Error = () => import('../views/Error.vue');
const Details = () => import('../views/Details.vue');

const routes = [
  {
    path: '/',
    name: 'table',
    component: Table,
    meta: {
      auth: false,
      title: 'SaaS Pricing Pages'
    }
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: Checkout,
    meta: {
      auth: false,
      title: 'SaaS Pricing Pages'
    }
  },
  {
    path: '/error',
    name: 'error',
    component: Error,
    meta: {
      auth: false,
      title: 'SaaS Pricing Pages'
    }
  },
  {
    path: '/pro/:hash',
    name: 'complete',
    component: Table,
    meta: {
      auth: false,
      title: 'SaaS Pricing Pages Pro'
    }
  },
  {
    path: '/:company/:hash?',
    name: 'details',
    component: Details,
    meta: {
      auth: false,
      title: 'SaaS Pricing Pages'
    }
  },
  {
    path: '/old',
    name: 'home',
    component: Home
  }
]

export default routes;